import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0dedce10"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "scan__wrapper" }

import BasicForm from '@components/basic/BasicForm.vue'
import useScanner from '@/composable/useScanner'
import { IBasicForm } from '@/const/types/form'
import { required } from '@vuelidate/validators'
import { useRouter } from 'vue-router'

import {
    IonPage,
    IonHeader,
    IonToolbar,
    IonTitle,
    IonContent,
} from '@ionic/vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ScanPlaceProvideCodeView',
  setup(__props) {

const router = useRouter()
const scanner = useScanner({ onScan(itemCode) { provideCodeForResult(itemCode) }});

const schema: IBasicForm = {
    name: 'Scan and find article.',
    inputs: [
        {
            name: 'placeCode',
            label: 'Provide place code',
            type: 'basic',
            validation: { required },
        },
    ],
    handlers: {
        onSuccess(inputsValues) {
            const { placeCode } = (inputsValues as { placeCode: string })
            provideCodeForResult(placeCode) 
        }
    },
}

const provideCodeForResult = (placeCode: string) => router.push({ name: 'scan/place-result', params: { code: placeCode } })


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonHeader), null, {
        default: _withCtx(() => [
          _createVNode(_unref(IonToolbar), null, {
            default: _withCtx(() => [
              _createVNode(_unref(IonTitle), null, {
                default: _withCtx(() => [
                  _createTextVNode("WMS | Scan place")
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(IonContent), { fullscreen: true }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(BasicForm, { schema: schema })
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})